import React from "react";
import AddSource from "./AddSource";
import { graphql, QueryRenderer } from "react-relay";
import environment from "./Environment";
import { GC_USER_ID, GC_AUTH_TOKEN } from "./constants";
import Spinner from "./Spinner";

const sourcesQuery = graphql`
    query AddSourceContainer_allSources_Query(
        $searchBy: String!
        $byCategory: String
    ) {
        allSources(searchBy: $searchBy, byCategory: $byCategory) {
            ...AddSource_allSources
        }
    }
`;

function AddSourceContainer(props) {
    const searchBy = props.settings.sourceString;
    const categoryId = props.settings.categoryId;

    const user = props.user;
    const settings = props.settings;

    return (
        <QueryRenderer
            environment={environment}
            query={sourcesQuery}
            variables={{ searchBy: searchBy, byCategory: categoryId }}
            render={({ error, props }) => {
                if (error) throw error;
                if (!props) return <div> <Spinner isLoading={true} /> </div>;
                return (
                    <div>
                        <AddSource
                            user={user}
                            settings={settings}
                            allSources={props.allSources}
                        />
                    </div>
                );
            }}
        />
    );
}

export default AddSourceContainer;
